<section class="is-flex is-fullwidth">
  <ng-container *ngIf="icon !== ''">
    <app-icon class="text-40 has-spacing-right-s" [name]="icon"></app-icon>
  </ng-container>
  <app-text class="title has-spacing-right-m"
    [text]="name">
  </app-text>
  <app-text
    *ngIf="hasText"
    [ngClass]="{'fixed-size': type === 'time', 'is-v-align-start': icon === ''}"
    class="title is-align-end"
    [text]="getText()">
  </app-text>
</section>

<div class="is-fullwidth is-relative">
  <app-slider
    class="is-fullwidth"
    [(ngModel)]="input"
    (ngModelChange)="changeValue($event)"
    [min]="min"
    [max]="max"
    [step]="step">
  </app-slider>
</div>

<section class="is-flex is-fullwidth" *ngIf="!legend">
  <app-text
    class="subtitle subtitle-text text-grey-90 has-no-margin-bottom text-14"
    [text]="displayMin.toString()">
  </app-text>
  <app-text
    class="subtitle subtitle-text is-align-end text-grey-90 text-14"
    [text]="displayMax.toString()">
  </app-text>
</section>
<section class="is-flex is-fullwidth is-space-between" *ngIf="legend">
    <div *ngFor="let legendText of legend" class="flex-column">
      <app-text class="subtitle" [text]="legendText + valueUnit"></app-text>
  </div>
</section>
